<script>
  import {
    StructuredData,
    Favicons,
    Analytics,
    // MySPH,
    Meta,
  } from '@st-graphics/graphics-components';
  import { copyJson } from '$lib/stores/st-lf.svelte';
  import { browser } from '$app/environment';

  $effect(() => {
    if (browser && window.mySPHConfig) {
      window.mySPHConfig.providers = window.mySPHConfig.providers.filter(
        (item) => item !== 'googleOneTap'
      );
    }
  });
</script>

<Meta
  title={copyJson.data?.title}
  meta={copyJson.data?.meta || { tags: '' }}
  header={copyJson.data?.header || { byline: '' }}
/>

<StructuredData
  title={copyJson.data?.title}
  pubdate={copyJson.data?.header?.datetime}
  header={copyJson.data?.header || { byline: '' }}
  credits={copyJson.data?.credits || {}}
  meta={copyJson.data?.meta || {}}
/>

<Favicons />

<Analytics
  title={copyJson.data?.title}
  pubdate={copyJson.data?.header?.datetime}
/>

<!-- <MySPH /> -->
